// extracted by mini-css-extract-plugin
module.exports = {"searchBarContainer":"SearchBar_searchBarContainer__GLw4S","title":"SearchBar_title__a3DYt"};